import React from "react";
import createReactClass from "create-react-class";
import PropTypes from "prop-types";
import * as UU5 from "uu5g04";
import "uu5g04-forms";

import ns from "ns";

import "./table-cell-text-input.less";

export const TableCellTextInput = createReactClass({
  //@@viewOn:mixins
  mixins: [
    UU5.Common.BaseMixin,
    UU5.Common.PureRenderMixin,
    UU5.Common.ElementaryMixin,
    UU5.Common.NestingLevelMixin,
    UU5.Common.ContentMixin,
    UU5.Common.ColorSchemaMixin,
    UU5.Forms.InputMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: ns.tag("TableCell"),
    nestingLevelList: UU5.Environment.getNestingLevelList('bigBoxCollection', 'inline'),
    classNames: {
      main: ns.css("table-cell-text-input")
      //bg: 'uu5-common-bg'
    },
    opt: {
      nestingLevelWrapper: true
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    data: PropTypes.string,
    setFocus: PropTypes.func
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  getInitialState() {
    this._preventBlur = false;
    this._modalOpen = false;
    return {
      value: this.props.data,
      phase: "default"
    };
  },

  componentWillReceiveProps: function (nextProps) {
    this.setState({value: (nextProps.data)});
  },

  componentDidMount() {
    this._dccEditor = this.getParentByType("hasUuDccCommonDccMixin");
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getChild() {
    return (
      <UU5.Bricks.Div {...this._prepareProps()} />
    )
  },

  _prepareProps() {
    let mainProps = this.getMainPropsToPass();
    mainProps.mainAttrs = {
      onMouseOver: () => {
        if (!this._preventBlur) {
          this.setState({phase: "hover"});
        }
      },
      onMouseLeave: () => {
        this._preventBlur ? null : this.setState({phase: "default"});
      }
    };
    mainProps.content = this._getContent();
    return mainProps;
  },

  _getContent() {
    if (this.state.phase === "default") {
      return this.state.value;
    } else if (this.state.phase === "hover") {
      return (<UU5.Bricks.Div className="testdiv">
        <UU5.Bricks.Div content={this.state.value}/>
        <UU5.Bricks.Button className="button-open-modal" mainAttrs={{
          onMouseDown: () => {
            this._openModal();
            this._modalOpen = true;
          }
        }}>
          <UU5.Bricks.Icon icon="mdi-arrow-expand"/>
        </UU5.Bricks.Button></UU5.Bricks.Div>);
    } else {
      this._preventBlur = true;
      let uu5StringEditor = UU5.Common.Tools.findComponent("UU5.CodeKit.Uu5StringEditor", {
        focus: true,
        value: this.state.value,
        maxRows: 1000,
        height: "0px",
        fontSize: 14,
        rows: 0,
        showGutter: false,
        wrapEnabled: true,
        onChange: (opt) => this.setState({value: opt.value}),
        ref_: (textIcon) => this._editoruu5 = textIcon
      });
      return (
        <UU5.Bricks.Div className="div-uu5stringeditor div-uu5stringeditor-focused">
          {uu5StringEditor}
          <UU5.Bricks.Button className="button-open-modal"
                             mainAttrs={{
                               onMouseDown: () => {
                                 this._openModal();
                                 this._modalOpen = true;
                               }
                             }}>
            <UU5.Bricks.Icon icon="mdi-arrow-expand"/>
          </UU5.Bricks.Button>
        </UU5.Bricks.Div>
      )
    }
  },

  doFocus() {
    this._preventBlur = true;
    this.setState({phase: "focus"});
  },

  doBlur() {
    this._preventBlur = false;
    this.setState({phase: "default"});
  },

  _openModal() {
    this._dccEditor.fireDccEvent("EVENT_COMPONENT_START_PROCESS", {
      componentId: this.getId(),
      content: this._openModalEdit()
    });
  },

  _openModalEdit() {
    return ({
      className: "uudcc-modal-uu5string",
      size: "l",
      header: <UU5.Bricks.Div className="uu-dockit-form-header"
                              content={<UU5.Bricks.Lsi lsi={{cs: "Úprava buňky", en: "Edit cell"}}/>}/>,
      content: UU5.Common.Tools.findComponent("UuDcc.Bricks.UuDccCodeEditor", {
        save: (data) => this._saveFromModalToState(data),
        close: () => this._closeModal(),
        data: this.state.value,
        dccCaptionsLsi: this._dccEditor.getLsi()
      })
    })
  },

  _saveFromModalToState(newText) {
    this._modalOpen = false;
    this._preventBlur = true;
    this.setState({value: newText});
    this._dccEditor.fireDccEvent("EVENT_COMPONENT_END_PROCESS", {componentId: this.getId()});
    this.props.setFocus();
  },

  _closeModal() {
    this._modalOpen = false;
    this._preventBlur = true;
    this._dccEditor.fireDccEvent("EVENT_COMPONENT_END_PROCESS", {componentId: this.getId()});
    this.props.setFocus();
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return this.getNestingLevel() ? this._getChild() : null;
  }
  //@@viewOff:render
});

export default TableCellTextInput;



// WEBPACK FOOTER //
// ./bricks/table-cell-text-input.js